module.exports = __webpack_public_path__ + "media/Tapping How to Play Button.c933412e.mp3";